// FeaturesGrid.tsx
const features = [
  "No Noise",
  "Faster Service",
  "Modern Look",
  "Wireless",
  "Long Battery Life",
  "Easy Setup",
];

export function FeaturesGrid() {
  return (
    <section className="py-32 px-6" data-lenis-scroll>
      <div className="max-w-6xl mx-auto grid sm:grid-cols-2 md:grid-cols-3 gap-12">
        {features.map((feature) => (
          <div
            key={feature}
            className="p-8 border border-neutral-200 rounded-2xl text-center text-sm"
          >
            {feature}
          </div>
        ))}
      </div>
    </section>
  );
}
